import angular from 'angular';
import '@uirouter/angularjs';
import 'angular-breadcrumb';
import 'ng-table';
import './users/usersControllers';
import './apps/appsControllers';
import {accessLevels} from '../services/accessLevels';

/**
 * @ngdoc overview
 * @name adminModule
 * @description
 * Module for managing the administration of: users and applications.
 */
const adminModule = angular.module('adminModule', [
    'ui.router',
    'adminModule.appsControllers',
    'adminModule.usersControllers',
    'ncy-angular-breadcrumb',
    'ngTable'
]);

adminModule.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('appsoup.admin', {
            abstract: true,
            url: '/admin',
            ncyBreadcrumb: {
                label: 'MODULES.ADMIN.TITLE'
            },
            template: '<ui-view/>'
        })
        .state('appsoup.admin.users', {
            url: '/users',
            templateUrl: 'views/admin/users/users.tpl.html',
            controller: 'UsersListController',
            ncyBreadcrumb: {
                label: 'MODULES.USERS.TITLE'
            },
            accessLevel: accessLevels.user
        })
        .state('appsoup.admin.userEdit', {
            url: '/users/edit/:userId',
            templateUrl: 'views/admin/users/user.tpl.html',
            controller: 'UserPageController',
            ncyBreadcrumb: {
                label: 'MODULES.USERS.EDIT',
                parent: 'appsoup.admin.users'
            },
            menuActive: 'appsoup.admin.users',
            accessLevel: accessLevels.user
        })
        .state('appsoup.admin.userNew', {
            url: '/users/new/:duplicateUserId?',
            templateUrl: 'views/admin/users/user.tpl.html',
            controller: 'UserPageController',
            ncyBreadcrumb: {
                label: 'MODULES.USERS.NEW',
                parent: 'appsoup.admin.users'
            },
            menuActive: 'appsoup.admin.users',
            accessLevel: accessLevels.user
        })
        .state('appsoup.admin.apps', {
            url: '/apps',
            templateUrl: 'views/admin/apps/apps.tpl.html',
            controller: 'AppsListController',
            ncyBreadcrumb: {
                label: 'MODULES.APPS.TITLE'
            },
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.newApp', {
            url: '/apps/new',
            templateUrl: 'views/admin/apps/app.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPS.NEW_APP',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.editApp', {
            url: '/app/:appId',
            templateUrl: 'views/admin/apps/app.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appPages', {
            url: '/app/:appId/pages',
            templateUrl: 'views/admin/apps/pages.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appModules', {
            url: '/app/:appId/modules',
            templateUrl: 'views/admin/apps/modules.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appAttributes', {
            url: '/app/:appId/attributes/module/:module',
            templateUrl: 'views/admin/apps/attributes.tpl.html',
            controller: 'AppAttributeController',
            ncyBreadcrumb: {
                label: 'MODULES.ATTRIBUTES.LIST',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.editAttribute', {
            url: '/app/:appId/attributes/module/:module/edit/:key',
            templateUrl: 'views/admin/apps/attribute.tpl.html',
            controller: 'AppAttributeController',
            ncyBreadcrumb: {
                label: 'MODULES.ATTRIBUTES.EDIT',
                parent: 'appsoup.admin.appAttributes'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.newAttribute', {
            url: '/app/:appId/attributes/module/:module/new',
            controller: 'AppAttributeController',
            templateUrl: 'views/admin/apps/attribute.tpl.html',
            ncyBreadcrumb: {
                label: 'MODULES.ATTRIBUTES.NEW',
                parent: 'appsoup.admin.appAttributes'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appUserStructure', {
            url: '/app/:appId/user-structure',
            templateUrl: 'views/admin/apps/user_structure.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appCommunicationPush', {
            url: '/app/:appId/communication-push',
            templateUrl: 'views/admin/apps/communication-push.tpl.html',
            controller: 'AppCommunicationPushController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.wwwStructure', {
            url: '/app/:appId/www-structure',
            templateUrl: 'views/admin/apps/www_structure.tpl.html',
            controller: 'AppPageController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        })
        .state('appsoup.admin.appPlacementTypes', {
            url: '/app/:appId/placement-types',
            templateUrl: 'views/admin/apps/placement_types.tpl.html',
            controller: 'AppPlacementTypesController',
            ncyBreadcrumb: {
                label: 'MODULES.APPLICATIONS.EDIT',
                parent: 'appsoup.admin.apps'
            },
            menuActive: 'appsoup.admin.apps',
            accessLevel: accessLevels.application
        });
}]);

export default adminModule.name;
